// covered-by: services/christo/lib/services/__tests__/askPunttOpenItems.test.ts
// covered-by: qa/rickrubin/tests/api/ask-puntt-projects.spec.ts
import { z } from "zod";

export const askPunttOpenItemKindSchema = z.enum([
  "project_blocker",
  "missing_input",
  "vague_requirement",
  "unjudged_finding",
  "expert_question",
  "source_conflict",
]);
export type AskPunttOpenItemKind = z.infer<typeof askPunttOpenItemKindSchema>;

export const askPunttOpenItemSchema = z.object({
  id: z.string(),
  kind: askPunttOpenItemKindSchema,
  needed: z.string(),
  ownerUserId: z.string().nullable(),
  openedAt: z.union([z.string(), z.date()]),
  fileId: z.string().nullable(),
  fileName: z.string().nullable().optional(),
  sourceId: z.string(),
  sourceKind: z.enum([
    "attention",
    "finding",
    "participation",
    "approval",
    "conflict",
    "agent",
  ]),
  reviewTicketId: z.string().nullable().optional(),
  commentId: z.string().nullable().optional(),
  status: z.enum(["open", "cleared"]).optional(),
  suggestions: z.array(z.string()).optional(),
  severity: z.string().optional(),
});
export type AskPunttOpenItem = z.infer<typeof askPunttOpenItemSchema>;

export const listAskPunttProjectOpenItemsRequestSchema = z.object({
  params: z.object({ projectId: z.string() }),
});
export const listAskPunttProjectOpenItemsResponseSchema = z.object({
  openItems: z.array(askPunttOpenItemSchema),
  doneAt: z.union([z.string(), z.date()]).nullable(),
  mayAssignOpenItems: z.boolean().optional(),
  canMarkProjectDone: z.boolean().optional(),
});
export type ListAskPunttProjectOpenItemsResponse = z.infer<
  typeof listAskPunttProjectOpenItemsResponseSchema
>;

/** Composer attachment for an open item on the project rail (Ask V2). */
export const askPunttOpenItemContextSchema = z.object({
  id: z.string().min(1),
  kind: askPunttOpenItemKindSchema,
  needed: z.string().min(1),
});
export type AskPunttOpenItemContext = z.infer<
  typeof askPunttOpenItemContextSchema
>;

export const askPunttOpenItemContextsSchema = z
  .array(askPunttOpenItemContextSchema)
  .max(1);

export const markAskPunttProjectDoneRequestSchema = z.object({
  params: z.object({ projectId: z.string() }),
  body: z
    .object({
      override: z.boolean().optional(),
    })
    .default({}),
});
export const markAskPunttProjectDoneResponseSchema = z.object({
  done: z.literal(true),
  doneAt: z.union([z.string(), z.date()]),
  override: z.boolean(),
  items: z
    .array(
      z.object({
        id: z.string(),
        kind: askPunttOpenItemKindSchema,
        needed: z.string(),
        ownerUserId: z.string().nullable(),
        fileId: z.string().nullable(),
      }),
    )
    .optional(),
});

export const assignAskPunttOpenItemRequestSchema = z.object({
  params: z.object({ projectId: z.string(), itemId: z.string() }),
  body: z.object({ ownerUserId: z.string().min(1) }),
});

export const nudgeAskPunttOpenItemRequestSchema = z.object({
  params: z.object({ projectId: z.string(), itemId: z.string() }),
});

export const nudgeAskPunttOpenItemResponseSchema = z.object({
  nudged: z.literal(true),
  message: z.string(),
});

export const listAskPunttOpenItemAssigneesResponseSchema = z.object({
  assignees: z.array(
    z.object({
      userId: z.string(),
      name: z.string(),
    }),
  ),
});
export type MarkAskPunttProjectDoneResponse = z.infer<
  typeof markAskPunttProjectDoneResponseSchema
>;
